import { useState, useEffect } from "react";
import { X, Trash2 } from "lucide-react";

const STAGES = ["new","contacted","qualified","proposal","negotiation","won","lost"];
const SOURCES = ["facebook_ads","whatsapp","phone_call","website","referral","manual","other"];

export default function LeadDrawer({ open, onClose, lead, onSaved }) {
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setForm(lead ? { ...lead } : { stage: "new", source: "manual" });
  }, [lead, open]);

  if (!open) return null;

  const set = (field, val) => setForm(prev => ({ ...prev, [field]: val }));

  // const save = async () => {
  //   setSaving(true);
  //   if (lead?.id) {
  //     await base44.entities.Lead.update(lead.id, form);
  //   } else {
  //     await base44.entities.Lead.create(form);
  //   }
  //   setSaving(false);
  //   onSaved();
  //   onClose();
  // };

  
const save = async () => {
  setSaving(true);

  if (lead?.id) {
    // Update existing lead
    await fetch(`/api/leads/${lead.id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(form),
    });
  } else {
    // Create new lead
    await fetch("/api/leads", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(form),
    });
  }

  setSaving(false);
  onSaved();
  onClose();
};
//   const remove = async () => {
//     if (!lead?.id) return;
//     await base44.entities.Lead.delete(lead.id);
//     onSaved();
//     onClose();
//   };
const remove = async () => {
  if (!lead?.id) return;

  await fetch(`/api/leads/${lead.id}`, {
    method: "DELETE",
  });

  onSaved();
  onClose();
};
  return (
    <>
      <div className="drawer-overlay" onClick={onClose} />
      <div className="drawer">
        <div className="drawer-header">
          <span className="drawer-title">{lead ? "Edit Lead" : "New Lead"}</span>
          <button className="btn btn-ghost btn-icon" onClick={onClose}><X size={18} /></button>
        </div>

        <div className="drawer-body">
          {[
            { field:"name", label:"Name *" },
            { field:"email", label:"Email", type:"email" },
            { field:"phone", label:"Phone" },
            { field:"company", label:"Company" },
            { field:"value", label:"Deal Value ($)", type:"number" },
            { field:"assigned_to", label:"Assigned To" },
          ].map(({ field, label, type }) => (
            <div key={field} className="form-group">
              <label className="form-label">{label}</label>
              <input
                className="form-input"
                type={type ?? "text"}
                value={form[field] ?? ""}
                onChange={e => set(field, type === "number" ? Number(e.target.value) : e.target.value)}
              />
            </div>
          ))}

          <div className="form-group">
            <label className="form-label">Stage</label>
            <select className="form-select" value={form.stage ?? "new"} onChange={e => set("stage", e.target.value)}>
              {STAGES.map(s => <option key={s} value={s}>{s}</option>)}
            </select>
          </div>

          <div className="form-group">
            <label className="form-label">Source</label>
            <select className="form-select" value={form.source ?? "manual"} onChange={e => set("source", e.target.value)}>
              {SOURCES.map(s => <option key={s} value={s}>{s.replace("_"," ")}</option>)}
            </select>
          </div>

          <div className="form-group">
            <label className="form-label">Notes</label>
            <textarea className="form-textarea" rows={4} value={form.notes ?? ""} onChange={e => set("notes", e.target.value)} />
          </div>
        </div>

        <div className="drawer-footer">
          {lead && (
            <button className="btn btn-danger btn-icon" onClick={remove} title="Delete lead">
              <Trash2 size={15} />
            </button>
          )}
          <button className="btn btn-primary" style={{ flex:1 }} onClick={save} disabled={saving || !form.name}>
            {saving ? "Saving..." : lead ? "Update Lead" : "Create Lead"}
          </button>
        </div>
      </div>
    </>
  );
}